import axios from 'axios'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../../Context/AuthProvider'
import { useState } from 'react'
import moment from 'moment'
import { url } from '../../Constant'
import { checkPermissions, checkIndividualPermission } from '../../Utils/PermissionFunctions'
import Linechart from '../../components/Graph/Linechart'




const Graphs = () => {

    const { auth } = useAuth();
    const [STARTDATE, setSTARTDATE] = useState(
      ''
    );
    const [ENDDATE, setENDDATE] = useState(
      ''
    );
  
    const [extensionNumber, setExtensionNumber] = useState("");
    const [graphDataAdmin, setGraphDataAdmin] = useState();
    const [loader, setLoader] = useState(false);
    const [topAgent, setTopAgent] = useState({
        inbound: null,
        outbound: null,
      });
    const [isSearched, setIsSearched] = useState(false);
    const [extensionList, setExtensionList] = useState([]);




      useEffect(() => {
        console.log(topAgent , 'topAgent')
      })




    const getGraphForAdminfetchData = (endpoint, data) => {
        setLoader(true);
        axios
          .post(endpoint, data, {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          })
          .then(
            (response) => {
              if (
                response.status === 200 &&
                response.data.message === "Data Found"
              ) {
                setGraphDataAdmin(response.data.data);
                setLoader(false);
              } else {
                setLoader(false);
                console.log("No data found or unexpected response format");
              }
            },
            (error) => {
              setLoader(false);
              console.log("Error fetching graph data:", error);
            }
          );
      };

    // Get extensions list
    const getExtensions = () => {
      if (auth.role === "2") {
        axios
          .post(
            url + "get-all-extensions",
            {
              vpbx_id: auth.vpbx_id,
            },
            {
              headers: {
                Authorization: `Bearer ${auth.token}`,
              },
            }
          )
          .then(
            (response) => {
              if (response.status === 200) {
                if (response.data.message === "Data Found") {
                  setExtensionList(response.data.data);
                }
              }
            },
            (error) => {
              console.log(error);
            }
          );
      } else if (auth.role === "3") {
        axios
          .post(
            url + "user-get-all-extensions",
            {
              vpbx_id: auth.vpbx_id,
            },
            {
              headers: {
                Authorization: `Bearer ${auth.token}`,
              },
            }
          )
          .then(
            (response) => {
              if (response.status === 200) {
                if (response.data.message === "Data Found") {
                  setExtensionList(response.data.data);
                }
              }
            },
            (error) => {
              console.log(error);
            }
          );
      }
    };

    // Define getGraphForAdmin function based on role and vpbx_id
    let getGraphForAdmin;
    if (auth.role === "2") {
      if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
        getGraphForAdmin = () =>
          getGraphForAdminfetchData(url + "postex-graph-details", {
            vpbx_id: auth.vpbx_id,
            start_date: STARTDATE,
            end_date: ENDDATE,
            extension_number: extensionNumber,
          });
      } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
        getGraphForAdmin = () =>
          getGraphForAdminfetchData(url + "leopard-graph-details", {
            vpbx_id: auth.vpbx_id,
            start_date: STARTDATE,
            end_date: ENDDATE,
            extension_number: extensionNumber,
          });
      } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
        getGraphForAdmin = () =>
          getGraphForAdminfetchData(url + "tcs-graph-details", {
            vpbx_id: auth.vpbx_id,
            start_date: STARTDATE,
            end_date: ENDDATE,
            extension_number: extensionNumber,
          });
      } else if (auth.vpbx_id === process.env.REACT_APP_TRAVEL) {
        getGraphForAdmin = () =>
          getGraphForAdminfetchData(url + "travel-channel-graphDetails", {
            vpbx_id: auth.vpbx_id,
            start_date: STARTDATE,
            end_date: ENDDATE,
            extension_number: extensionNumber,
          });
      } else {
        getGraphForAdmin = () =>
          getGraphForAdminfetchData(url + "company_graph_details", {
            vpbx_id: auth.vpbx_id,
            start_date: STARTDATE,
            end_date: ENDDATE,
            extension_number: extensionNumber,
          });
      }
    } else if (auth.role === "1") {
      getGraphForAdmin = () =>
        getGraphForAdminfetchData(url + "graph_details", {
          vpbx_id: auth.vpbx_id,
          start_date: STARTDATE,
          end_date: ENDDATE,
        });
    } else if (auth.role === "3") {
      if (auth.vpbx_id === process.env.REACT_APP_POSTEX_VPBX) {
        getGraphForAdmin = () =>
          getGraphForAdminfetchData(url + "user-postex-graph-details", {
            vpbx_id: auth.vpbx_id,
            start_date: STARTDATE,
            end_date: ENDDATE,
            extension_number: extensionNumber,
          });
      } else if (auth.vpbx_id === process.env.REACT_APP_LEOPARD_VPBX) {
        getGraphForAdmin = () =>
          getGraphForAdminfetchData(url + "user-leopard-graph-details", {
            vpbx_id: auth.vpbx_id,
            start_date: STARTDATE,
            end_date: ENDDATE,
            extension_number: extensionNumber,
          });
      } else if (auth.vpbx_id === process.env.REACT_APP_TCS_VPBX) {
        getGraphForAdmin = () =>
          getGraphForAdminfetchData(url + "user-tcs-graph-details", {
            vpbx_id: auth.vpbx_id,
            start_date: STARTDATE,
            end_date: ENDDATE,
            extension_number: extensionNumber,
          });
      } else {
        getGraphForAdmin = () =>
          getGraphForAdminfetchData(url + "user_graph_details", {
            vpbx_id: auth.vpbx_id,
            start_date: STARTDATE,
            end_date: ENDDATE,
            extension_number: extensionNumber,
          });
      }
    }
      



    const TopAgentfetchData = (endpoint) => {
        axios
          .post(
            endpoint,
            {
              vpbx_id: auth.vpbx_id,
              start_date: STARTDATE,
              end_date: ENDDATE,
            },
            {
              headers: {
                Authorization: `Bearer ${auth.token}`,
              },
            }
          )
          .then(
            (response) => {
              if (
                response.status === 200 &&
                response.data.message === "Data Found"
              ) {
                let inboundData = [];
                let outboundData = [];
                response.data.data.forEach((val) => {
                  inboundData.push(val.inbound);
                  outboundData.push(val.outbound);
                });
                setTopAgent({
                  inbound: inboundData,
                  outbound: outboundData,
                });
              }
            },
            (error) => {
              console.log(error);
            }
          );
      };


    
    

    // Search handle click function
    const searchhandleClick = () => {
      setLoader(true);
      getGraphForAdmin();
    };

    useEffect(() => {
      // Check if user has permission to access this page
      if (auth.role === "3") {
        if (!checkPermissions("dashboard")) {
          window.location.href = "/";
        }
      }
      
      // Get extensions list
      getExtensions();
      
      // Call API functions
      if (getGraphForAdmin) {
        getGraphForAdmin();
      }
      
    }, [STARTDATE, ENDDATE, extensionNumber, auth.role, auth.vpbx_id]);




  return (
    <div className="dashboardWrp">
        <div className="uk-container uk-container-large">
            <div className="dashboardTop">
                <div uk-grid="" className="uk-grid uk-grid-small">
                    <div className="uk-width-1-1">
                    <div className="dashboardTop">
                      <div uk-grid="" className="uk-grid uk-grid-small">
                        <div className="uk-width-1-2">
                          <div className="dashboardIntro">
                            <h3>
                              GRAPHS{" "}
                            </h3>
                            <h4></h4>
                          </div>
                        </div>

                        <div className="uk-width-1-2">
                          <div className=" uk-text-right">
                            {isSearched === false ? (
                              (auth.role === "2" ||
                                checkIndividualPermission(
                                  "dashboard",
                                  "read_and_write"
                                )) && (
                                <button
                                  className="exportData-button"
                                  onClick={() => setIsSearched(true)}
                                >
                                  Add Filter
                                </button>
                              )
                            ) : (
                              <button
                                className="exportData-button"
                                onClick={() => setIsSearched(false)}
                              >
                                Close Filter
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      
                      {isSearched === true && (
                        <div className="uk-flex uk-flex-between uk-margin-top">
                          <div>
                            <div className="dashboardIntro">
                              <h3>
                                <span className="companyName">Filter</span>
                              </h3>
                            </div>
                          </div>
                          <div>
                            <div className="uk-flex uk-flex-between">
                              <div className="uk-flex uk-flex-between">
                                <div style={{ margin: "10px" }}>
                                  <label>Start Date</label>
                                </div>
                                <div>
                                  <input
                                    type="date"
                                    className="uk-input"
                                    onChange={(e) => {
                                      let date = e.target.value;
                                      setSTARTDATE(moment(date).format("YYYY-MM-DD"));
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="uk-flex uk-flex-between">
                                <div style={{ margin: "10px" }}>
                                  <label> End Date </label>
                                </div>
                                <div>
                                  <input
                                    type="date"
                                    className="uk-input"
                                    onChange={(e) => {
                                      let date = e.target.value;
                                      setENDDATE(moment(date).format("YYYY-MM-DD"));
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="uk-flex uk-flex-between">
                                <div style={{ margin: "10px" }}>
                                  <label> Extension </label>
                                </div>
                                <div>
                                  <select
                                    name="type"
                                    onChange={(e) => {
                                      setExtensionNumber(e.target.value);
                                    }}
                                    className="uk-select"
                                  >
                                    <option value="" selected disabled>
                                      please select Extension type
                                    </option>
                                    {extensionList?.map((val, index) => {
                                      return (
                                        <option key={index} value={val}>
                                          {val}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </div>
                              </div>
                              <div>
                                <button
                                  className="exportData-button"
                                  onClick={searchhandleClick}
                                >
                                  {loader ? (
                                    <div uk-spinner="" className="loader">
                                      {/* Searching  */}
                                    </div>
                                  ) : (
                                    "Search"
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    </div>
                </div>
            </div>

            <div
              uk-grid=""
              uk-height-match="target: div > .uk-card"
              className="uk-grid uk-grid-small"
            >
            


              <div className="uk-width-1-1">
                <div className="uk-card uk-card-default uk-card-small uk-card-body CampaignOverview">
                  <div className="head">
                    <h5>Campaign Overview</h5>
                  </div>
                  {/* Chart */}
                  <div className="ChannelsOverviewGraph">
                    <Linechart
                      labels={graphDataAdmin?.labels}
                      data1={graphDataAdmin?.inbound}
                      data2={graphDataAdmin?.outound}
                      name1="Inbound calls"
                      name2="Outbound Calls"
                    />
                  </div>
                </div>
              </div>


              </div>

        </div>
    </div>
  )
}

export default Graphs